import React from "react"
import { BiDownload } from "react-icons/bi"

const WhitePaperButton = ({ displayName, path, onClick }) => {
  return (
    <div className="submenu-item-container" onClick={onClick}>
      <a
        data-cy={`download-white-paper-button`}
        className="download-white-paper-button"
        href={path}
        target="_blank"
        rel="noopener noreferrer"
      >
        <BiDownload />
        <span>Download {displayName}</span>
      </a>
    </div>
  )
}

export default WhitePaperButton
